import { Box } from "@mui/material";
import { BarChart } from "@mui/x-charts";
import { memo, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { DashboardNoData } from "../DashboardNoData/DashboardNoData";
import { useDashboard } from "../../../../../store/contexts/DashBoardContext";
import { IDashboardBarChartProps } from "./models";

const TRANSLATION_PATH = "components.panel.";

export const DashboardBarChart = memo(({ data }: IDashboardBarChartProps) => {
  const { t } = useTranslation();
  const { width } = useDashboard();

  if (!data || Object.keys(data).length === 0) {
    return <DashboardNoData />;
  }

  // eslint-disable-next-line
  const dataset = useMemo(
    () =>
      Object.entries(data).map(([key, value]) => ({
        tickets: value,
        hour: key,
      })),
    [data],
  );

  return (
    <Box
      sx={(t) => ({
        mt: 1,
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: `1px solid ${t.palette.divider}`,
        borderRadius: 2,
        backgroundColor: t.palette.background.default,
        minHeight: 250,
      })}
    >
      <BarChart
        dataset={dataset}
        xAxis={[
          {
            dataKey: "hour",
            scaleType: "band",
            label: t(TRANSLATION_PATH + "xAxis") || "Hours",
          },
        ]}
        yAxis={[{ label: "Tickets" }]}
        series={[{ dataKey: "tickets" }]}
        width={width ? width * 0.8 : 500}
        height={300}
      />
    </Box>
  );
});
